import AppContext from 'App/AppContext';
import { IPCheckbox, IPFontIcon, IPLabel } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { canUpdateTaskField, TaskFieldTypes } from 'components/Tasks/TaskAuthHelper';
import { globalStackTokensGapExtraSmall, globalStackTokensGapMedium } from 'globalStyles';
import Task from 'models/tasks/task';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { iconFontSize, readOnlyRowSpace } from './TaskDetailStyles';

interface ITaskDetailStatusActiveProps {
  orgTask: Task;
  task: Task;
  canUpdate: boolean;
  onUpdate: (newTask: Task) => void;
  checkOnly: boolean;
}

export const TaskDetailStatusActive = (props: ITaskDetailStatusActiveProps) => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation(['task', 'translation']);
  const isReadonly = !canUpdateTaskField(props.orgTask, props.canUpdate, TaskFieldTypes.Status, appContext);

  const getCheck = () => {
    return (
      <IPStack.Item>
        <IPLabel>{t('task:Status.Label')}</IPLabel>
        <IPCheckbox
          label={t('task:Status.Active')}
          checked={props.task.taskStateId !== props.task.getCompletedState()}
          onChange={(ev, checked) => {
            const newTask = props.task.clone();
            if (checked === true) {
              newTask.taskStateId = newTask.getFirstState();
            } else {
              newTask.taskStateId = newTask.getCompletedState();
            }
            props.onUpdate(newTask);
          }}
          disabled={isReadonly}
        />
      </IPStack.Item>
    );
  };

  //
  // Main render
  //
  if (props.checkOnly) {
    return getCheck();
  } else {
    return (
      <IPStack
        horizontal
        tokens={appContext.isMobileView ? globalStackTokensGapExtraSmall : globalStackTokensGapMedium}
        verticalAlign="start"
        styles={isReadonly ? { root: { paddingBottom: readOnlyRowSpace } } : undefined}
      >
        <IPStack.Item>
          {!appContext.isMobileView && <IPFontIcon iconName="FavoriteStarFill" style={iconFontSize} />}
        </IPStack.Item>
        {getCheck()}
      </IPStack>
    );
  }
};
